import { createSlice } from "@reduxjs/toolkit";

export interface AuthPromptState {
  isSignInPromptOpen: boolean;
}

const initialState: AuthPromptState = {
  isSignInPromptOpen: false,
};

const authPromptSlice = createSlice({
  name: "authPrompt",
  initialState,
  reducers: {
    openSignInPrompt(state) {
      state.isSignInPromptOpen = true;
    },
    closeSignInPrompt(state) {
      state.isSignInPromptOpen = false;
    },
  },
});

export const { openSignInPrompt, closeSignInPrompt } = authPromptSlice.actions;
export const authPromptReducer = authPromptSlice.reducer;



